import styled, { keyframes, css } from 'styled-components';

const leftMove = keyframes`
  0% {
    opacity: 0;
    transform : translateX(200px);
  }
  100% {
    opacity: 1;
    transform : translateX(0px);
  }
`;

const growing = keyframes`
  0% {
    opacity: 0;
    flex: 0;
    transform : translateX(200px);
  }
  100% {
    opacity: 1;
    flex: 1;
    transform : translateX(0px);
  }
`;

export const RowItem = styled.div`
  overflow: hidden;
  cursor: pointer;
  background-color: white;
  position: relative;
  align-items: center;
  display: flex;
  font-size: 0.875rem;
  line-height: 1.43;
  letter-spacing: 0.01071em;
  ${props => !props.disableAnimation && css`animation: ${leftMove} ${200 + (props.index * 40)}ms linear;`}
  border-radius: 5px;
  padding: 0;
`;

export const ItemTitle = styled.div`
  padding: 0 5px;
  flex: 0 0 auto;
`;

export const Buttons = styled.div`
  position: relatice;
  display: flex;
  animation: ${growing} 200ms linear;
`;